import React from 'react';

/**
 * Gradient dùng chung cho tất cả khung avatar (SVG <defs>) — mount MỘT LẦN ở layout gốc.
 * Các khung avatar tham chiếu qua url(#afSteel)… nên id phải là duy nhất toàn app.
 */
const AvatarFrameDefs = () => (
  <svg width="0" height="0" aria-hidden focusable="false" style={{ position: 'absolute' }}>
    <defs>
      <linearGradient id="afSteel" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#94a3b8" />
        <stop offset="50%" stopColor="#334155" />
        <stop offset="100%" stopColor="#0f172a" />
      </linearGradient>
      <linearGradient id="afCobalt" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#38bdf8" />
        <stop offset="50%" stopColor="#0284c7" />
        <stop offset="100%" stopColor="#075985" />
      </linearGradient>
      <linearGradient id="afPurple" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e879f9" />
        <stop offset="40%" stopColor="#a855f7" />
        <stop offset="80%" stopColor="#581c87" />
        <stop offset="100%" stopColor="#2e1065" />
      </linearGradient>
      <linearGradient id="afGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fef08a" />
        <stop offset="25%" stopColor="#f59e0b" />
        <stop offset="60%" stopColor="#b45309" />
        <stop offset="100%" stopColor="#451a03" />
      </linearGradient>
      <linearGradient id="afObsidian" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#475569" />
        <stop offset="50%" stopColor="#1e293b" />
        <stop offset="100%" stopColor="#020617" />
      </linearGradient>
      <linearGradient id="afCrimson" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fca5a5" />
        <stop offset="30%" stopColor="#dc2626" />
        <stop offset="70%" stopColor="#7f1d1d" />
        <stop offset="100%" stopColor="#18181b" />
      </linearGradient>
      <linearGradient id="afVoidPurple" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c084fc" />
        <stop offset="50%" stopColor="#7e22ce" />
        <stop offset="100%" stopColor="#3b0764" />
      </linearGradient>
    </defs>
  </svg>
);

export default AvatarFrameDefs;
